"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _paper = _interopRequireDefault(require("@scratch/paper"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactRedux = require("react-redux");
var _selection = require("../../helper/selection");
var _fixedToolsModule = _interopRequireDefault(require("./fixed-tools.module.css"));
var _group = require("../../helper/group");
var _material = require("@mui/material");
var SvgInfo = function SvgInfo(props) {
  var selectedItems = (0, _reactRedux.useSelector)(function (state) {
    return state.scratchPaint.selectedItems;
  });
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    itemType = _useState2[0],
    setItemType = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    idAdded = _useState4[0],
    setIdAdded = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    isTextOnly = _useState6[0],
    setIsTextOnly = _useState6[1]; // set to true if all elements selected are text

  (0, _react.useEffect)(function () {
    setItemType(true);
    setIsTextOnly(false);
    if (selectedItems && selectedItems[0]) {
      var parents = [];
      parents.push(selectedItems[0]);
      var parentStack = (0, _selection.findGreaterParent)(selectedItems[0], parents);
      var greaterParent = parentStack[parentStack.length - 2];
      var greaterParentItemType = greaterParent && greaterParent.className ? greaterParent.className : "";

      // Check if atleast one child/grandchild is a Path or a CompoundPath or a PointText, then set itemType as true
      if (greaterParentItemType && greaterParentItemType === "Group" && greaterParent._children) {
        var isText = (0, _selection.checkIfAllAreText)(greaterParent._children);
        if (isText) {
          setIsTextOnly(true);
        } else {
          var type = (0, _selection.checkIfEditable)(greaterParent._children);
          setItemType(type);
        }
      } // If not a group, then check if it is a Path or a CompoundPath or a PointText
      // If not any any of these, then set itemType as false
      else if (greaterParentItemType && greaterParentItemType === "PointText") {
        setIsTextOnly(true);
      } else if (greaterParentItemType && greaterParentItemType !== "Path" && greaterParentItemType !== "CompoundPath"
      // && greaterParentItemType !== 'PointText' to be reverted
      ) {
        setItemType(false);
      }
    }
  }, [selectedItems]);
  var _useState7 = (0, _react.useState)(),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    seatNumber = _useState8[0],
    setSeatNumber = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    odcNumber = _useState10[0],
    setOdcNumber = _useState10[1];
  var _useState11 = (0, _react.useState)(),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    availableSeatNumber = _useState12[0],
    setAvailableSeatNumber = _useState12[1];
  // useEffect(() => {
  //     let seatCount = fetchSvgInfo()
  //     setSeatNumber(seatCount)
  // }, [])

  (0, _react.useEffect)(function () {
    var seatInfo = fetchSvgSeatInfo();
    setSeatNumber(seatInfo[0]);
    setOdcNumber(seatInfo[1].length);
    setAvailableSeatNumber(seatInfo[2]);
    if (!idAdded) {
      //  addSeatIds();
    }
  }, [(0, _selection.getAllSelectableRootItems)()]);

  // from line 85 to 101 required for setting seat backend id
  // const addSeatIds = (items = getAllSelectableRootItems()) => {
  //   for (const item of items) {
  //     setIdAdded(true);
  //     if (
  //       item &&
  //       item._data &&
  //       item._data.id &&
  //       props.seatIds &&
  //       props.seatIds[item._data.id]
  //     ) {
  //       item._data.seatBackendId = props.seatIds[item._data.id];
  //     }
  //     if (item.className && item.className === "Group" && item._children) {
  //       addSeatIds(item._children);
  //     }
  //   }
  // };

  // in the case where the item is grouped and does not satisfy the criteria to become a seat
  //ie an id and 'clickable' attribute, then check inside as well.
  var fetchSvgSeatInfo = function fetchSvgSeatInfo() {
    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _selection.getAllSelectableRootItems)();
    var seatNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var availableSeatNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var groupNames = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    var _iterator = (0, _createForOfIteratorHelper2.default)(items),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        if (item._data && item._data.id && item._data.customAttributes) {
          var attr = item._data.customAttributes;
          var unavailable = item._data.unavailable;
          var capacity = parseInt(item._data.capacity);
          var capacityValue = capacity ? capacity : 1;
          if (attr.some(function (obj) {
            return obj.value === "clickable";
          })) {
            // if it contains clickable, take color backup and change the colors
            storeColorBackup([item]);
            item.fillColor = "#9FF8F3";
            item.strokeColor = "#00B7BE";
            //    seatNumber = seatNumber + capacityValue;
            seatNumber++;
            if (item._data.groupName && !groupNames.includes(item._data.groupName.value)) {
              groupNames.push(item._data.groupName.value);
            }
            if (!unavailable) {
              availableSeatNumber++;
            }
          } else {
            //has an id but no clickable attribute
            // if it does not contain clickable
            removeColorFromChildren([item]);
            setTimeout(function () {
              //    removeOriginalColorTagFromChildren([item])
            }, 100);
            if (item.className && item.className === "Group" && item._children) {
              var _fetchSvgSeatInfo = fetchSvgSeatInfo(item._children, seatNumber, availableSeatNumber, groupNames);
              var _fetchSvgSeatInfo2 = (0, _slicedToArray2.default)(_fetchSvgSeatInfo, 3);
              seatNumber = _fetchSvgSeatInfo2[0];
              groupNames = _fetchSvgSeatInfo2[1];
              availableSeatNumber = _fetchSvgSeatInfo2[2];
            }
          }
        } // has no id
        else if (!item._data || item._data && !item._data.id) {
          if (item.className && item.className === "Group" && item._children) {
            var _fetchSvgSeatInfo3 = fetchSvgSeatInfo(item._children, seatNumber, availableSeatNumber, groupNames);
            var _fetchSvgSeatInfo4 = (0, _slicedToArray2.default)(_fetchSvgSeatInfo3, 3);
            seatNumber = _fetchSvgSeatInfo4[0];
            groupNames = _fetchSvgSeatInfo4[1];
            availableSeatNumber = _fetchSvgSeatInfo4[2];
          }
        }
        // if it does not contain customAttributes
        if (item._data && "originalColor" in item._data && !item._data.customAttributes) {
          removeColorFromChildren([item]);
          setTimeout(function () {
            //    removeOriginalColorTagFromChildren([item])
          }, 100);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return [seatNumber, groupNames, availableSeatNumber];
  };
  var storeColorBackup = function storeColorBackup(items) {
    var _iterator2 = (0, _createForOfIteratorHelper2.default)(items),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var item = _step2.value;
        if (item.className === "Path" || item.className === "CompoundPath" || item.className === "Group" || item.className === "PointText") {
          if (item._data && !item._data.hasOwnProperty("originalColor")) {
            item._data.originalColor = [];
            var fillColor = item.fillColor;
            var strokeColor = item.strokeColor;
            // Convert the fill color to a JSON object
            var fillColorJSON = fillColor && fillColor.exportJSON();
            var strokeColorJSON = strokeColor && strokeColor.exportJSON();
            if (item.fillColor) {
              item._data.originalColor[0] = fillColorJSON;
            }
            if (item.strokeColor) {
              item._data.originalColor[1] = strokeColorJSON;
            }
          }
        }
        if (item.className === "Group" && item._children) {
          storeColorBackup(item._children);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  };
  var removeColorFromChildren = function removeColorFromChildren(items) {
    var _iterator3 = (0, _createForOfIteratorHelper2.default)(items),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var item = _step3.value;
        if (item.className === "Path" || item.className === "CompoundPath" || item.className === "Group" || item.className === "PointText") {
          if (item._data && item._data.hasOwnProperty("originalColor")) {
            if (item._data.originalColor[0]) {
              var fillColor = item._data.originalColor[0] && _paper.default.Color.importJSON(item._data.originalColor[0]);
              item.fillColor = fillColor;
            } else {
              item.fillColor = null;
            }
            if (item._data.originalColor[1]) {
              var strokeColor = item._data.originalColor[1] && _paper.default.Color.importJSON(item._data.originalColor[1]);
              item.strokeColor = strokeColor;
            } else {
              item.strokeColor = null;
            }
            //    delete item._data.originalColor
          }
        }

        if (item.className === "Group" && item._children) {
          removeColorFromChildren(item._children);
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  };
  var removeOriginalColorTagFromChildren = function removeOriginalColorTagFromChildren(items) {
    var _iterator4 = (0, _createForOfIteratorHelper2.default)(items),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var item = _step4.value;
        if (item.className === "Path" || item.className === "CompoundPath" || item.className === "Group" || item.className === "PointText") {
          if (item._data && "originalColor" in item._data) {
            delete item._data.originalColor;
          }
        }
        if (item.className === "Group" && item._children) {
          removeOriginalColorTagFromChildren(item._children);
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  };
  // const fetchSvgOdcCount = () => {
  //     const values = groupNameStackOfAllItems();
  //     const uniqueValues = [];
  //     const uniqueObjects = [];
  //     const unique = values.filter(element => {
  //       const isDuplicate = uniqueValues.includes(element.value);

  //       if (!isDuplicate) {
  //         uniqueValues.push(element.value);
  //         uniqueObjects.push(element)
  //         return true;
  //       }

  //       return false;
  //     });
  //     return uniqueObjects.length
  // }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: _fixedToolsModule.default.infoWarningWrap
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _fixedToolsModule.default.seat_info_container
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      fontSize: "0.875rem"
    }
  }, "Number of Seats: "), "\xA0", /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      fontSize: "0.875rem"
    }
  }, seatNumber), "\xA0\xA0\xA0", /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      fontSize: "0.875rem"
    }
  }, "Available Seats: "), "\xA0", /*#__PURE__*/_react.default.createElement(_material.Typography, {
    sx: {
      fontSize: "0.875rem"
    }
  }, availableSeatNumber)), isTextOnly && (0, _group.selectedSingleItem)() ? /*#__PURE__*/_react.default.createElement("div", {
    className: _fixedToolsModule.default.warningMessage
  }, /*#__PURE__*/_react.default.createElement("p", null, "Text elements can't be assigned"), " ") : null, !isTextOnly && !itemType && (0, _group.selectedSingleItem)() ? /*#__PURE__*/_react.default.createElement("div", {
    className: _fixedToolsModule.default.warningMessage
  }, /*#__PURE__*/_react.default.createElement("p", null, "Selected element appears to be non-editable. You cannot assign values for a non-editable element on the map. Please re-upload the revised map or try deleting it and adding the seat from the tool panel on the left.")) : null);
};
var _default = SvgInfo;
exports.default = _default;